import { Component, OnInit } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { HttpCommunicationService } from "../../../service/http-communication.service";
import { catchError, map, Observable, of } from "rxjs";
import { BulkNotificationDto, BulkNotificationStatusEnum, NotificationBulkDto, NotificationBulkFilterDto, NotificationBulkTriggerDto } from "../../../service/dto";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzTableQueryParams } from "ng-zorro-antd/table";
import { Router } from "@angular/router";

@Component({
	selector: 'app-communication-scheduled-automated',
	standalone: false,
	templateUrl: './communication-scheduled-automated.component.html',
	styleUrl: './communication-scheduled-automated.component.scss'
})
export class CommunicationScheduledAutomatedComponent implements OnInit {

	bulkPayload!: BulkNotificationDto[];
	loading = false;
	total = 0;
	pageSize = 10;
	pageIndex = 1;

	constructor(
		private router: Router,
		private message: NzMessageService,
		private httpService: HttpCommunicationService,
		private modalService: NzModalService,) {}

	ngOnInit(): void {
		this.fetch();
	}

	getThis(): CommunicationScheduledAutomatedComponent {
		return this;
	}
	
	onQueryParamsChange(params: NzTableQueryParams, that: CommunicationScheduledAutomatedComponent): void {
		const { pageIndex, pageSize } = params;
		if (pageIndex == that.pageIndex && pageSize == that.pageSize) {
			return;
		}
		that.pageIndex = pageIndex;
		that.pageSize = pageSize;

		this.fetch();
	}

	private fetch() {
		this.loading = true;
		this.httpService.getScheduledAutomated(this.pageIndex, this.pageSize)
		.pipe(
			catchError(error => {
				console.log('Error fetching scheduled and automated communications', error);
				this.message.error('Failed to fetch scheduled and automated communications');
				throw error;
			})
		)
		.subscribe({
			next: (res) => {
				this.loading = false;
				this.bulkPayload = res.list;
				this.total = res.totalItems;
				this.pageIndex = res.pageIndex;
				this.pageSize = res.pageSize;
			},
			error: () => {
				this.loading = false;
			},
		});
	}

	editSchedule(item: BulkNotificationDto) {
		this.router.navigate(['/communication/send', item.bulk?.id])
	}

	toggleStatus(item: BulkNotificationDto): Observable<boolean> {
		if (!item.bulk) {
			return of(false);
		}

		const newStatus = item.bulk.status === 'Active' ? 'Disabled' : 'Active';
		const action = newStatus === 'Active' ? 'Enable' : 'Disable';

		return this.confirmStatus(item, newStatus, action);
	}

	private confirmStatus(item: BulkNotificationDto, newStatus: BulkNotificationStatusEnum, action: string): Observable<boolean> {
		return new Observable<boolean>(observer => {
			this.modalService.confirm({
				nzTitle: `${action} communication`,
				nzContent: `Are you sure you wish to ${action} this communication?`,
				nzOkText: action,
				nzCancelText: 'Cancel',
				nzOnOk: () => {
					item.bulk!.status = newStatus;
					this.doAction(item.bulk);
					observer.next(true);
					observer.complete();
				},
				nzOnCancel: () => {
					observer.next(false);
					observer.complete();
				}
			});
		});
	}

	private doAction(bulk: NotificationBulkDto | undefined) {
		if (!bulk) {
			return;
		}
		this.httpService.changeStatus(bulk)
		.pipe(
			map(() => true),
			catchError(error => {
				console.log('Error changing status', error);
				this.message.error('Failed to change status: ' + (error.error?.error ?? error.message));
				return of(false);
			})
		)
		.subscribe(success => {
			if (success) {
				this.message.success("Status changed successfully");
			} else {
				const revertStatus = bulk.status === 'Active' ? 'Disabled' : 'Active';
				bulk.status = revertStatus;
			}
		});
	}

	onExpand(item: any) {
		this.bulkPayload.forEach(x => {
			if (x !== item) x.expanded = false;
		});
	}
}